import { useCallback } from "react";

import { useRequestWithFeedback } from "../../../composites";

import API from "./api";

import type { OnboardingPromptResponse, GuidePlatform } from "./types";
import type { ApiError } from "../../../../types/models/v1/Error.types";
import type { OverrideRunProps } from "../../../composites";

export const useFetchOnboardingPrompts = () => {
  const { send, loading } = useRequestWithFeedback<
    OnboardingPromptResponse,
    ApiError
  >();

  const fetchOnboardingPrompts = useCallback(
    (
      platform: GuidePlatform,
      overrideRunProps?: OverrideRunProps<OnboardingPromptResponse>,
    ) => {
      send({
        action: API.getOnboardingPrompts(platform),
        ...overrideRunProps,
      });
    },
    [send],
  );

  return { fetchOnboardingPrompts, loading };
};

export const useMarkOnboardingPromptComplete = () => {
  const { send, loading } = useRequestWithFeedback<Record<string, never>>();

  const markPromptComplete = useCallback(
    (
      uuid: string,
      overrideRunProps: OverrideRunProps<Record<string, never>> = {},
    ) => {
      send({
        action: API.markPromptComplete(uuid),
        ...overrideRunProps,
      });
    },
    [send],
  );

  return { markPromptComplete, loading };
};
